/**
 * Converte uma string base64 em um objeto Blob.
 *
 * @param base64 - A string base64 contendo os dados do arquivo.
 * @param mimeType - O tipo MIME do arquivo (ex: "image/jpeg").
 * @returns Um objeto Blob que pode ser enviado via FormData.
 */
export const base64ToBlob = (base64: string, mimeType: string): Blob => {
  const byteCharacters = atob(base64.split(",")[1]); // Decodifica o base64
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};
